<template>
  <div id="wrapper">
    <Nav :message="message" />
    <BlogList />
  </div>
</template>
<script>
// @ is an alias to /src
import Nav from '@/components/Nav.vue'
import BlogList from '@/components/website/BlogList.vue'

export default {
  name: 'Absence',
  props: ['message'],
  components: {
    Nav,
    BlogList
  }
}
</script>